import * as React from "react";
import { longPressDurationMs } from "./useLongPress";

const chargeFadeDurationMs = 160;

export function useHoldCharge(isHolding: boolean, enabled: boolean) {
    const surfaceRef = React.useRef<HTMLSpanElement>(null);
    const progressRef = React.useRef(0);

    React.useEffect(() => {
        if (!enabled) {
            return;
        }
        let animationFrame: number | undefined;
        const startedAt = performance.now();
        const previousProgress = progressRef.current;
        const paint = (progress: number) => {
            progressRef.current = progress;
            surfaceRef.current?.style.setProperty(
                "--emotion-hold-charge", String(progress),
            );
        };
        if (isHolding) {
            paint(0);
        } else if (previousProgress === 0) {
            return;
        }
        const animateCharge = (now: number) => {
            const duration = isHolding ? longPressDurationMs : chargeFadeDurationMs;
            const elapsed = Math.min(1, (now - startedAt) / duration);
            paint(isHolding ? elapsed : previousProgress * (1 - elapsed));
            if (elapsed < 1) {
                animationFrame = window.requestAnimationFrame(animateCharge);
            }
        };
        animationFrame = window.requestAnimationFrame(animateCharge);
        return () => {
            if (animationFrame !== undefined) {
                window.cancelAnimationFrame(animationFrame);
            }
        };
    }, [isHolding, enabled]);

    return surfaceRef;
}
